import React, { useState, useMemo } from 'react';
import { Button, Box } from '@mui/material';
import DialogModal from '../../../components/DialogModal';
import DropdownSelect, {
  DropdownSelectOption
} from '../../../components/DropdownSelect/DropdownSelect';
import { generatePaymentImageUrl } from '../utils/generatePaymentImageUrl';

import { StudentPaymentSchemeWithMetrics } from '../../../types/paymentScheme';

interface ViewPaymentImageDialogProps {
  open: boolean;
  onClose: () => void;
  userDetails: any;
  allPaymentSchemes: StudentPaymentSchemeWithMetrics[];
}

const ViewPaymentImageDialog: React.FC<ViewPaymentImageDialogProps> = ({
  open,
  onClose,
  userDetails,
  allPaymentSchemes
}) => {
  const [academicYear, setAcademicYear] = useState('');
  const [iframeSrc, setIframeSrc] = useState('');
  const [showIframe, setShowIframe] = useState(false);

  const isShowDisabled = !academicYear || showIframe;

  const handleShow = () => {
    const generatedUrl = generatePaymentImageUrl(
      userDetails,
      academicYear,
      allPaymentSchemes
    );
    setIframeSrc(generatedUrl);
    setShowIframe(true);
  };

  const academicYears: DropdownSelectOption[] = useMemo(
    () =>
      userDetails?.studentDetails?.rollOverInfo?.map((info: any) => ({
        value: info.academicYear,
        label: info.academicYear
      })) || [],
    [userDetails]
  );

  React.useEffect(() => {
    if (open && academicYears.length > 0 && !academicYear) {
      setAcademicYear(academicYears[0].value);
    }
  }, [open, academicYears, academicYear]);

  React.useEffect(() => {
    setIframeSrc('');
    setShowIframe(false);
  }, [academicYear]);

  const dialogActions = (
    <Button
      variant='contained'
      onClick={handleShow}
      sx={{ textTransform: 'none' }}
      disabled={isShowDisabled}
    >
      Show
    </Button>
  );

  return (
    <DialogModal
      open={open}
      onClose={() => {
        onClose();
        setAcademicYear('');
        setIframeSrc('');
        setShowIframe(false);
      }}
      title='View Payment Image'
      maxWidth='md'
      actions={dialogActions}
    >
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <DropdownSelect
            label='Academic Year'
            placeholder='Select Academic Year'
            value={academicYear}
            options={academicYears}
            onChange={(e) => setAcademicYear(e.target.value as string)}
            name='academicYear'
            fullWidth
            hasTopLabel
          />
        </Box>
        <Box sx={{ flex: 1 }} />
      </Box>

      {showIframe && iframeSrc && (
        <Box sx={{ mt: 2, width: '100%', height: '500px' }}>
          <iframe
            src={iframeSrc}
            title='Payment Image'
            width='100%'
            height='100%'
            style={{ border: 'none' }}
          />
        </Box>
      )}
    </DialogModal>
  );
};

export default ViewPaymentImageDialog;
